import { RiBold, RiCodeSSlashLine, RiItalic, RiStrikethrough, RiUnderline } from "@remixicon/react";
import { KEYS } from "platejs";
import { useEditorReadOnly } from "platejs/react";
import { MarkToolbarButton } from "./mark-toolbar-button";
import { ToolbarGroup } from "./toolbar";
import { TurnIntoToolbarButton } from "./turn-into-toolbar-button";

export function FloatingToolbarButtons() {
	const readOnly = useEditorReadOnly();

	if (readOnly) return null;

	return (
		<ToolbarGroup>
			<TurnIntoToolbarButton />

			<MarkToolbarButton nodeType={KEYS.bold} tooltip="Bold (Cmd+B)">
				<RiBold />
			</MarkToolbarButton>
			<MarkToolbarButton nodeType={KEYS.italic} tooltip="Italic (Cmd+I)">
				<RiItalic />
			</MarkToolbarButton>
			<MarkToolbarButton nodeType={KEYS.underline} tooltip="Underline (Cmd+U)">
				<RiUnderline />
			</MarkToolbarButton>
			<MarkToolbarButton nodeType={KEYS.strikethrough} tooltip="Strikethrough">
				<RiStrikethrough />
			</MarkToolbarButton>
			<MarkToolbarButton nodeType={KEYS.code} tooltip="Code (Cmd+E)">
				<RiCodeSSlashLine />
			</MarkToolbarButton>
		</ToolbarGroup>
	);
}
